import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { API } from '@/config';
import { toast } from 'sonner';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

export default function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthFromGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    if (!code) {
      toast.error('Google sign-in failed');
      navigate('/login', { replace: true });
      return;
    }

    const redirectUri = window.location.origin + '/auth/google/callback';

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google/callback`, { code, redirect_uri: redirectUri });
        setAuthFromGoogle(res.data.token, res.data.user);
        toast.success('Signed in with Google!');
        navigate('/dashboard', { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Google sign-in failed');
        navigate('/login', { replace: true });
      }
    })();
  }, [searchParams, navigate, setAuthFromGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="h-8 w-8 text-[#10B981] animate-spin mx-auto mb-4" />
        <p className="text-sm text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
}
